export default "__VITE_ASSET__BhVIu483__"